<div [attr.aria-expanded]="isOpen"
     [class.work-ui-accordion-item--is-disabled]="isDisabled"
     [class.work-ui-accordion-item--no-padding]="noPadding"
     [class.work-ui-accordion-item--with-border]="withBorder"
     class="work-ui-accordion-item"
     role="tab">
  <div #heading
       (click)="toggle()"
       [class.no-hover-effect]="headerNoHoverEffect"
       [class.open]="isOpen"
       [class.space-between]="headerIconSpaceBetween"
       [ngClass]="noPadding ? 'gap-8' : 'gap-24'"
       aria-level="4"
       class="flex flex-row vertical-center"
       role="heading">
    <ng-content select="[accordion-header]" />
    <div class="flex flex-row gap-16 vertical-center">
      <ng-content select="[accordion-icon]" />
      @if (!hideIcon) {
        <work-ui-icon [fontSize]="40"
                      name="add" />
      }
    </div>
  </div>
  <div [class.open]="isOpen"
       role="region">
    <div class="content">
      <ng-content select="[accordion-content]" />
    </div>
  </div>
</div>
